"use client";

import React from "react";

import { CloseButton } from "@/ui/CloseButton";
import { cn } from "@/utils/cn";

import { withScrollLock } from "../../HOC/ScrollLock";

import styles from "./style.module.scss";

interface ModalProps {
  children: React.ReactNode;
  onClose?: () => void;
  isFullScreen?: boolean;
  closeColor?: "red" | "dark" | "white";
}

const Modal = ({
  children,
  onClose,
  isFullScreen = false,
  closeColor = "red",
}: ModalProps) => {
  return (
    <div
      className={cn(
        styles.wrapper,
        styles.start,
        isFullScreen && styles.fullscreen,
        isFullScreen && '!w-full'
      )}
    >
      <div
        className={cn(
          styles.container,
          isFullScreen && styles.fullscreen,
          isFullScreen && "!w-full",
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={cn(
            styles.contentWrapper,
            isFullScreen && styles.fullscreen,
            isFullScreen && "!w-full !max-w-full",
          )}
        >
          {onClose && (
            <CloseButton
              size={27}
              color={closeColor}
              className={"absolute top-8 right-6 z-10"}
              onClick={onClose}
            />
          )}
          <div
            className={cn(
              styles.content,
              isFullScreen && styles.fullscreen,
              isFullScreen  && "!w-full",
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withScrollLock(Modal);
